import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import './styles/globals.css';
import { ContactPage } from './pages/contact-page';
import { FinancingPage } from './pages/financing-page';
import { IndexPage } from './pages/index-page';
import { AboutPage } from './pages/about-page';
import { InventoryPage } from './pages/inventory-page';
import  AddListing  from './pages/add-listing';
import Parts from './pages/accessories-and-spares'
import CategoryPage from './pages/category-page';
import PartDetails from './pages/part-details';
import CarHire from './pages/car-hire';
import Breakdown from './pages/breakdown';
import NotFoundPage from './pages/404';
import CarDetails from './pages/car-details';
import AdminLogin from './pages/admin-login';
import AdminRoute from './components/AdminRoute';
import GarageLogin from './pages/garage-login';
import GarageRoute from './components/GarageRoute';
import SEO from './components/SEO';
import GarageManagement from './pages/full-management';
import TopBanner from './components/top-banner';
import HostHome from './components/HostHome'; 
import AdminManagement from './pages/admin-management';
import BuyingProcess from './components/BuyingProcess';
import SellingProcess from './components/SellingProcess';
import GarageIndexPage from './pages/garage-index';
import Signup from './pages/signup';
import SellerLogin from './pages/seller-login';
import SellerRoute from './components/SellerRoute';
import SellerPortal from './pages/seller-portal';
import { TermsPage, PrivacyPage } from './pages/policy-page';
import { isAdminAuthenticated } from './api/auth';
const App = () => {
  const AdminOrSellerRoute = ({ children }) => isAdminAuthenticated() ? <AdminRoute>{children}</AdminRoute> : <SellerRoute>{children}</SellerRoute>;
  return (
    <>
    <TopBanner />
    <Router>
      <SEO />
      <ScrollToTop />
      <Routes>
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/garage-index" element={<GarageIndexPage />} />
        <Route path="/financing" element={<FinancingPage />} />
        <Route path="/" element={<HostHome />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/inventory" element={<InventoryPage />} />
        <Route path="/inventory/:id" element={<CarDetails />} />
        {/* superadmin (My Car staff): manages the marketplace catalog */}
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminRoute><AdminManagement /></AdminRoute>} />
        <Route path="/add-listing" element={<AdminOrSellerRoute><AddListing /></AdminOrSellerRoute>} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<SellerLogin />} />
        <Route path="/seller-login" element={<Navigate to="/login" replace />} />
        <Route path="/seller-portal" element={<SellerRoute><SellerPortal /></SellerRoute>} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        {/* garage tenant: manages their own bookings/jobs/customers/invoices */}
        <Route path="/garage-login" element={<GarageLogin />} />
        <Route path="/garage" element={<GarageRoute><GarageManagement/></GarageRoute>} />
        <Route path="/parts" element={<Parts />} />
        <Route path="/parts/item/:id" element={<PartDetails type="spare" />} />
        <Route path="/parts/:category" element={<CategoryPage type="spare" />} />
        <Route path="/accessories" element={<CategoryPage type="accessory" />} />
        <Route path="/accessories/item/:id" element={<PartDetails type="accessory" />} />
        <Route path="/accessories/:category" element={<CategoryPage type="accessory" />} />
        <Route path="/car-hire" element={<CarHire/>} />
        <Route path="/breakdown" element={<Breakdown/>} />
        <Route path="/buying" element={<BuyingProcess/>} />
        <Route path="/selling" element={<SellingProcess/>} />
        <Route path="*" element={<NotFoundPage/>}/>

      </Routes>
    </Router>
    </>
  );
};

export default App;